import cx from "classnames";

import { EntityChangeType } from "types/generated";
import { iconByType } from "components/Run/helpers";

import styles from "./styles.module.css";

type ChangeTypeIconProps = {
  type: EntityChangeType;
};

const ChangeTypeIcon = ({ type }: ChangeTypeIconProps) => {
  const icon = iconByType(type);
  return icon ? (
    <span className={cx(styles.icon, styles[String(type).toLowerCase()])}>{icon}</span>
  ) : null;
};

export default ChangeTypeIcon;
